/* eslint-disable @typescript-eslint/camelcase */
import { Grid } from '@material-ui/core';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import Button from 'components/Button';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import { PartnerFormFields } from 'modules/partners/interfaces';
import {
  deletePartnerRequest,
  editPartnerRequest,
} from 'modules/partners/actions';
import { selectCompany, selectPartner } from 'modules/authenticate/actions';
import FormPartner from '../Form';
import PartnersTemplate from '../PartnersTemplate';

interface Props {
  isLoading: boolean;
  isLoadingEditPartner: boolean;
  partner: PartnerFormFields | null;
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  editPartnerRequest: (values: PartnerFormFields) => void;
  deletePartnerRequest: ({ partnerUuid, company_uuid }) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  selectCompany: (company: CompanyData | null) => void;
  selectPartner: (partner: PartnerData | null) => void;
}

const Configurations = ({
  isLoading,
  partner,
  companySelected,
  isLoadingEditPartner,
  partnerSelected,
  editPartnerRequest,
  deletePartnerRequest,
  modalOpen,
  modalClose,
  selectCompany,
  selectPartner,
}: Props) => {
  const [values, setValues] = React.useState<PartnerFormFields | null>(null);
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const handleSubmit = values => {
    const partnerLdapType = partner?.active_directory?.ldap_type;

    if (partnerLdapType && ['external', 'managed'].includes(partnerLdapType)) {
      const data = { ...values };
      delete data?.active_directory?.admin_bind_pass;
      editPartnerRequest(data);
    } else editPartnerRequest(values);
  };

  const handleDeletePartner = () => {
    modalOpen({
      title: i18n.t('PARTNER_PAGE.REMOVE_PARTNER_KEY'),
      content: i18n.t('PARTNER_PAGE.REMOVE_PARTNER_QUESTION_KEY', {
        name: values?.name,
      }),
      maxWidth: 'sm',
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              deletePartnerRequest({
                partnerUuid: id,
                company_uuid: companySelected?.id,
              });
              if (partnerSelected?.id === id) {
                selectCompany(null);
                selectPartner(null);
                history.push('/all-partners');
              } else {
                history.push('/partners');
              }

              modalClose();
            }}
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  React.useEffect(() => {
    setValues(partner);
  }, [partner]);

  return (
    <PartnersTemplate
      current="configuration"
      title={i18n.t('CONFIG_KEY')}
      subtitle={i18n.t('PARTNER_PAGE.EDIT_PARTNER_DATA_KEY')}
      partnerName={partner?.name}
      breadcrumbs={[
        {
          name: i18n.t('PARTNERS_KEY'),
          link: '/partners',
        },
        {
          name: i18n.t('CONFIG_KEY'),
        },
      ]}
    >
      <Grid container>
        <Grid container>
          <FormPartner
            isEdit
            loadingEdit={isLoadingEditPartner}
            initialValues={values}
            isLoading={isLoading}
            onSubmit={handleSubmit}
            onDelete={handleDeletePartner}
          />
        </Grid>
      </Grid>
    </PartnersTemplate>
  );
};

const mapStateToProps = ({
  partners: { isLoading, partnerDetails, isLoadingEditPartner },
  authenticate: { companySelected, partnerSelected },
}: ApplicationState) => ({
  isLoading,
  isLoadingEditPartner,
  partner: partnerDetails,
  companySelected,
  partnerSelected,
});

export default connect(mapStateToProps, {
  editPartnerRequest,
  deletePartnerRequest,
  modalOpen,
  modalClose,
  selectCompany,
  selectPartner,
})(Configurations);
